import React from "react";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";

const AuditProgressSummary = ({
  progress,
  submitting,
  auditLocked,
  onSubmit,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems={{
        xs: "flex-start",
        md: "center",
      }}
      flexDirection={{
        xs: "column",
        md: "row",
      }}
      gap={2}
      mb={2}
    >
      <Box>
        <Typography>
          Assess each activity as not applicable,
          lacking a defined process, or having a
          defined process.
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          mt={0.5}
        >
          {progress.assessed} of {progress.total}{" "}
          assessed
          {" · "}
          {progress.definedProcessExists} defined
          {" · "}
          {progress.noDefinedProcess} without a
          defined process
          {" · "}
          {progress.notApplicable} not applicable
          {" · "}
          {progress.remaining} remaining
        </Typography>
      </Box>

      <Button
        variant="contained"
        color="secondary"
        onClick={onSubmit}
        disabled={submitting || auditLocked}
      >
        {submitting
          ? "Completing..."
          : "Complete Audit"}
      </Button>
    </Box>
  );
};

export default AuditProgressSummary;